import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageReviewStatusHistory } from '@/api/model/interfaces';

export default class DrawingPackageReviewStatusHistoryOdata extends OdataManager<DrawingPackageReviewStatusHistory> {}
